import { createFileRoute } from "@tanstack/react-router";

import { PaidMediaOverviewPage } from "@/components/paid-media/overview/overview-v3-page";
import { ModulePreviewWrapper } from "@/components/layout/module-preview-wrapper";

export const Route = createFileRoute("/dashboard/paid-media/_layout/overview-v3")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <ModulePreviewWrapper module="ai_paid_media" moduleName="AI Paid Media">
      <PaidMediaOverviewPage />
    </ModulePreviewWrapper>
  );
}
